import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/media/plus.png'


const _withScopeId = n => (_pushScopeId("data-v-086b1b49"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-modal": "true",
  role: "dialog",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Dispositivos disponibles:", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_11 = {
  class: "modal-footer",
  style: {"justify-content":"space-between"}
}
const _hoisted_12 = {
  key: 0,
  class: "center"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  title: "Subir resolución",
  style: {"font-size":"1em","color":"teal"},
  class: "fas fa-upload"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Cargar ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  title: "Abrir camara",
  style: {"font-size":"1em","color":"Mediumslateblue"},
  class: "fas fa-lock-open"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Abrir ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  title: "Abrir camara",
  style: {"font-size":"1em","color":"Mediumslateblue"},
  class: "fas fa-lock"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Cerrar ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  title: "tomar foto",
  style: {"font-size":"1.5em","color":"Dodgerblue"},
  class: "fas fa-camera"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Tomar foto ")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "center"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  title: "tomar foto",
  style: {"font-size":"1.5em","color":"red"},
  class: "fas fa-trash"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Borrar ")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  title: "Rotar imagen",
  style: {"font-size":"1em","color":"teal"},
  class: "fas fa-rotate-right"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Rotar ")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_camera = _resolveComponent("camera")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isOpenClose)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.with_camera ? "Capturar o Cargar" : "Cargar") + " Foto", 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.OpenCloseModal())),
                  class: "btn-close"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(
                  _ctx.state.formData.picture && !_ctx.cameraFrontal
                    ? 'col-md-12 mt-10 mb-10'
                    : 'col-md-12'
                )
                  }, [
                    (!_ctx.state.formData.picture && _ctx.cameraFrontal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _hoisted_7,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deviceSelected) = $event)),
                            class: "form-select fuente mb-3",
                            "aria-label": "select",
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.chooseDevice(_ctx.deviceSelected)))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devicesList, (list) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: list.deviceId,
                                key: list.deviceId
                              }, _toDisplayString(list.label), 9, _hoisted_8))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.deviceSelected]
                          ]),
                          _createVNode(_component_camera, {
                            resolution: { width: 500, height: 500 },
                            autoplay: "",
                            ref: "camera"
                          }, null, 512)
                        ]))
                      : (_ctx.state.formData.picture)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.state.formData.picture,
                            class: "img-fluid col-md-12 img-thumbnail transition",
                            width: "450",
                            height: "450",
                            alt: "picture"
                          }, null, 8, _hoisted_9))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            src: _imports_0,
                            class: "img-fluid img-thumbnail",
                            style: _normalizeStyle(
                    _ctx.v$.formData.picture.$error ? 'border: 5px solid red' : ''
                  ),
                            width: "450",
                            height: "450",
                            alt: "without_picture"
                          }, null, 4)),
                    (_ctx.v$.formData.picture.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Debe agregar una imagen "))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  (!_ctx.state.formData.picture)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (!_ctx.cameraFrontal)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn px-3",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploadResolution('picture')))
                            }, _hoisted_15))
                          : _createCommentVNode("", true),
                        _createElementVNode("input", {
                          id: "picture",
                          type: "file",
                          ref: "file",
                          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                          accept: "image/*",
                          hidden: ""
                        }, null, 544),
                        (_ctx.with_camera)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!_ctx.cameraFrontal)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn px-3",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openCamera()))
                                  }, _hoisted_18))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn px-3",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openCamera()))
                                  }, _hoisted_21)),
                              (_ctx.cameraFrontal)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "btn px-3",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.snapshot()))
                                  }, _hoisted_24))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn px-3",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deletesnapshot()))
                        }, _hoisted_28),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn px-3",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.rotateImage && _ctx.rotateImage(...args)))
                        }, _hoisted_31)
                      ]))
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveImage()))
                  }, " Guardar ")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}